import type { MilkdownPlugin } from '@milkdown/kit/ctx';
import { parserCtx, prosePluginsCtx, schemaCtx, SchemaReady } from '@milkdown/kit/core';
import type { Plugin } from '@milkdown/kit/prose/state';

import { createTableCellImagePasteProsePlugin } from './tableCellImage';

/**
 * Crepe’s clipboard implements `handlePaste` and never runs ProseMirror’s `transformPasted`, so
 * {@link ./tableCellImage#createTableCellImageTransformPlugin} alone does not fix pasting an
 * `image-block` into a table cell. This prepends to `prosePluginsCtx` (same pattern as
 * {@link ./taskListOrphanPastePlugin}) and only returns `true` when we rewrite that paste.
 */
export const tableCellImagePastePlugin: MilkdownPlugin = (ctx) => {
  let prosePlugin: Plugin | undefined;

  return async () => {
    await ctx.wait(SchemaReady);

    prosePlugin = createTableCellImagePasteProsePlugin({
      getParser: () => ctx.get(parserCtx),
      getSchema: () => ctx.get(schemaCtx),
    });

    ctx.update(prosePluginsCtx, (ps) => [prosePlugin!, ...ps]);

    return () => {
      ctx.update(prosePluginsCtx, (ps) => ps.filter((p) => p !== prosePlugin));
    };
  };
};
